import React from 'react';
import styles from './Auth.organisms.AccountSelection.module.scss';
import i18n from 'i18n';


export class AccountSelction extends React.Component {
    render() {
        const {
            accountList,
            handleSelectAccount,
            handleAddEmail
        } = this.props;

        const accounts = accountList.map(account => {
            return <div className={styles["account-container"]} key={account} data-automation-id="select-account" onClick={() => { handleSelectAccount(account)}}>
                <i className={`${styles["icon"]} icon-avatar`}></i>
                <p className={styles["email"]}>{account} </p>
            </div>
        })
        return (
            <div className={styles["acct-selection-container"]}>
                <h1 className={styles["title"]}>{i18n.t("select.an.account")}</h1>
                <div className={styles["accountList"]}>
                    {accounts}
                <div className={`${styles["account-container"]} ${styles["add-email"]}`} key='add' data-automation-id="add-email" onClick={handleAddEmail}>
                    <p className={styles["icon-plus"]}>+</p>
                    <p className={styles["email"]}>{i18n.t("add.email")}</p>
                </div>
                </div>

            </div>
        )
    }

}


AccountSelction.propTypes = {};

export default AccountSelction;